<template>
    <div class="select-searchable" v-click-outside="closeDropdown">
        <button
            type="button"
            @click="toggleDropdown"
            class="dropdown-button"
            :disabled="loading"
        >
            <span>{{ selectedLabel || placeholder }}</span>

            <span class="right-section">
                <i v-if="loading" class="bx bx-loader bx-spin"></i>
                <i v-else class="arrow"><i class="bx bx-chevron-down"></i></i>
            </span>
        </button>

        <div
            v-if="open && !loading"
            class="dropdown-menu"
            :class="{ 'd-block': open }"
        >
            <input
                v-model="search"
                type="text"
                class="dropdown-search"
                placeholder="Busque..."
            />

            <ul class="dropdown-options">
                <li
                    v-for="option in filteredOptions"
                    :key="option[valueKey]"
                    @click="selectOption(option)"
                    class="dropdown-item"
                >
                    {{ option[labelKey] }}
                </li>
                <li v-if="filteredOptions.length === 0" class="no-results">
                    Sem resultados
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "SelectSearchable",

    props: {
        modelValue: {
            type: null,
            default: "",
        },
        options: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: "Selecione",
        },
        loading: {
            type: Boolean,
            default: false,
        },
        valueKey: {
            type: null,
            default: "value",
        },
        labelKey: {
            type: null,
            default: "label",
        },
    },

    data() {
        return {
            open: false,
            search: "",
        }
    },

    computed: {
        selectedLabel() {
            const selected = this.options.find(
                (opt) => opt[this.valueKey] === this.modelValue
            )
            return selected ? selected[this.labelKey] : ""
        },
        filteredOptions() {
            return this.options.filter((opt) =>
                opt[this.labelKey]
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
            )
        },
    },

    methods: {
        toggleDropdown() {
            if (!this.loading) {
                this.open = !this.open
                this.search = ""
            }
        },
        closeDropdown() {
            this.open = false
        },
        selectOption(option) {
            if (!option[this.valueKey]) {
                console.warn("valueKey invalid or value not found")
            }
            this.$emit("update:modelValue", option[this.valueKey] || option)
            this.open = false
        },
    },
}
</script>

<style scoped>
.select-searchable {
    position: relative;
    width: 220px;
}

.dropdown-button {
    width: 100%;
    padding: 8px 12px;
    border-radius: 24px;
    border: 1px solid #ccc;
    background: white;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dropdown-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.right-section {
    display: flex;
    align-items: center;
    gap: 6px;
}

.arrow {
    transition: transform 0.2s;
}
.arrow.open {
    transform: rotate(180deg);
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    margin-top: 4px;
    z-index: 9999;
    padding: 8px;
    min-height: 50px;
}

.dropdown-search {
    width: 100%;
    padding: 6px 10px;
    margin-bottom: 8px;
    border-radius: 8px;
    border: 1px solid #ccc;
}

.dropdown-options {
    max-height: 180px;
    overflow-y: auto;
    list-style: none;
    padding: 0;
    margin: 0;
}

.dropdown-item {
    padding: 6px 10px;
    border-radius: 6px;
    cursor: pointer;
}
.dropdown-item:hover {
    background-color: #f0f0f0;
}

.no-results {
    padding: 6px 10px;
    color: #888;
    font-style: italic;
}
</style>
